import React from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import './css/modern-ui.css';
import "./index.sass";
import './css/modal-footer-pill.css';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor, history } from './configStore';
import { ThemeProvider } from 'styled-components';
import * as serviceWorker from './serviceWorker';
import { ConnectedRouter } from 'connected-react-router';
import ReduxToastr from 'react-redux-toastr';
import { PostHogProvider } from '@posthog/react';
import AnalyticsService from './services/analytics/AnalyticsService';

//Theme
import colors from './utils/styles/colors';
import mediaTemplates from '@bit/wavfichacerta.fichacerta.styles-utils.media-templates';

//Routes
import Routes from './routes';

//AWS signin
import Amplify from 'aws-amplify';
import awsConfig from './aws-exports';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';
import WhatsappButton from './components/others/WhatsappButton';

Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: awsConfig.aws_project_region,
  aws_pubsub_endpoint: process.env.REACT_APP_AWS_PUBSUB_ENDPOINT,
}));

Amplify.configure(awsConfig);

const theme = {
  ...colors,
  ...mediaTemplates,
  disabled: false,
  dynamicPhoneButtonColor: "color_white"
}

const options = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2026-01-30', // Mantendo o default recomendado pela documentação atual
  opt_out_capturing_by_default: process.env.NODE_ENV === 'development',
};

const root = createRoot(document.getElementById('root'));

AnalyticsService.init();

root.render(
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={options}>
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <ConnectedRouter history={history}>
            <Routes />
          </ConnectedRouter>
        </ThemeProvider>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          progressBar
          closeOnToastrClick
        />
        <WhatsappButton

        />
      </PersistGate>
    </Provider>
  </PostHogProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
